interface GenderStepProps {
  value: string
  onChange: (gender: string) => void
  nickname: string
}

export function GenderStep({ value, onChange, nickname }: GenderStepProps) {
  const buttonBaseStyle =
    'flex-1 py-3 text-lg font-bold rounded-2xl border-2 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#FFA236]'
  const selectedStyle = 'bg-[#FFA236] text-white border-[#FFA236]'
  const unselectedStyle = 'border-[#FFA236]/20 text-gray-700 bg-white/70 backdrop-blur-sm hover:border-[#FFA236]'

  return (
    <div className='space-y-4'>
      <div className='space-y-2 mb-6 text-center'>
        <h2 className='text-[24px] font-[700] text-[#020202]'>
          {`반가워 ${nickname}!`}
          <br />
          그럼 이제 성별을 골라줘
        </h2>
      </div>
      <div className='flex flex-col space-y-4'>
        <button
          onClick={() => onChange('남성')}
          className={`${buttonBaseStyle} ${value === '남성' ? selectedStyle : unselectedStyle}`}
        >
          남성
        </button>
        <button
          onClick={() => onChange('여성')}
          className={`${buttonBaseStyle} ${value === '여성' ? selectedStyle : unselectedStyle}`}
        >
          여성
        </button>
        <button
          onClick={() => onChange('기타')}
          className={`${buttonBaseStyle} ${value === '기타' ? selectedStyle : unselectedStyle}`}
        >
          기타
        </button>
      </div>
    </div>
  )
}
